import { render, staticRenderFns } from "./DatosContratante.vue?vue&type=template&id=19282ed5"
import script from "./DatosContratante.vue?vue&type=script&lang=js"
export * from "./DatosContratante.vue?vue&type=script&lang=js"
import style0 from "./DatosContratante.vue?vue&type=style&index=0&id=19282ed5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports